import React, { useState, useEffect } from 'react';
import { API_URL } from '../config';
import './TopPicksLeaderboard.css';

const RANK_COLORS = ['#FFD700', '#C0C0C0', '#CD7F32', '#a78bfa', '#60a5fa'];
const RANK_EMOJIS = ['🥇', '🥈', '🥉', '4️⃣', '5️⃣'];

function TopPicksLeaderboard({ onUsePrompt }) {
  const [picks, setPicks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeIdx, setActiveIdx] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/top-weekly`)
      .then(r => r.json())
      .then(data => {
        setPicks(data.picks || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (!loading && picks.length === 0) return null;

  return (
    <div className="top-picks-section">
      <div className="top-picks-header">
        <span className="top-picks-trophy">🏆</span>
        <h3 className="top-picks-title">This Week's Top Picks</h3>
        <span className="top-picks-subtitle">Most loved designs from the community</span>
      </div>

      <div className="top-picks-list">
        {loading
          ? Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="top-pick-skeleton skeleton" style={{ animationDelay: `${i * 0.08}s` }} />
            ))
          : picks.map((design, i) => (
              <div
                key={design.id}
                className={`top-pick-item ${activeIdx === i ? 'expanded' : ''}`}
                onClick={() => setActiveIdx(activeIdx === i ? null : i)}
                role="button"
                tabIndex={0}
                onKeyDown={e => e.key === 'Enter' && setActiveIdx(activeIdx === i ? null : i)}
              >
                {/* Rank badge */}
                <div
                  className="top-pick-rank"
                  style={{ '--rank-color': RANK_COLORS[i] }}
                >
                  <span className="rank-emoji">{RANK_EMOJIS[i]}</span>
                  <span className="rank-num">#{i + 1}</span>
                </div>

                {/* Thumbnail */}
                <div className="top-pick-thumb-wrap">
                  <img
                    src={design.image_url}
                    alt={design.prompt}
                    className="top-pick-thumb"
                    loading="lazy"
                  />
                  <div className="top-pick-thumb-glow" style={{ '--rank-color': RANK_COLORS[i] }} />
                </div>

                {/* Info */}
                <div className="top-pick-info">
                  <p className="top-pick-prompt">
                    "{design.prompt && design.prompt.length > 60
                      ? design.prompt.slice(0, 60) + '…'
                      : design.prompt}"
                  </p>
                  <div className="top-pick-meta">
                    <span className="top-pick-likes">❤️ {design.likes} likes</span>
                    {design.created_at && (
                      <span className="top-pick-date">
                        {new Date(Number(design.created_at)).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                      </span>
                    )}
                  </div>
                </div>

                {/* CTA */}
                {onUsePrompt && (
                  <button
                    className="top-pick-use-btn"
                    onClick={e => {
                      e.stopPropagation();
                      onUsePrompt(design.prompt);
                      document.getElementById('create')?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    title="Use this prompt"
                  >
                    ✨ Use
                  </button>
                )}
              </div>
            ))}
      </div>
    </div>
  );
}

export default TopPicksLeaderboard;
